import _ from 'lodash';
import trim from './trim';

export function isFormValid(model, formValue) {
  const checkResult = model.check?.(formValue);
  return !Object.keys(checkResult).some((key) => checkResult[key]?.hasError);
}

/**
 * 处理 input blur 时，去除首尾空格
 * @param {*} e
 * @param {*} formValue
 */
export function getTrimFormValue(e, formValue) {
  const value = e.target?.value?.trim();
  return value ? trim(formValue) : formValue;
}
